<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">My Account</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card" id="myAccount">
              <div class="overlay" v-if="is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-header p-3">
                <h3 class="card-title">Personal Information</h3>
                <router-link :to="{ name: 'AuthProfile' }" class="text-dark edit-btn">
                  <i class="fa fa-edit"></i> Edit
                </router-link>
              </div>
              <div class="card-body">
                <div class="media align-items-center mb-3">
                  <img width="110" height="110" class="img-circle mr-3" alt="preview image" v-if="profile.avatar"
                    v-bind:src="profile.avatar" style="object-fit: cover" />
                </div>
                <div class="custom-list">
                  <ul>
                    <!--li>
                      <strong>Carnival ID</strong>
                      <span style="font-weight: bold">
                        {{ accountInfo.id }}
                      </span>
                    </li>-->
                    <li>
                      <strong>User ID</strong>
                      <span style="font-weight: bold">
                        {{ accountInfo.cuid }}
                      </span>
                    </li>
                    <li>
                      <strong>Name</strong>
                      <span style="font-weight: bold">
                        {{ accountInfo.username }}
                      </span>
                    </li>
                    <li><strong>Phone</strong> {{ accountInfo.phone }}</li>
                    <li><strong>Email</strong>{{ accountInfo.email }}</li>
                    <li><strong>Address</strong>{{ accountInfo.address }}</li>
                  </ul>
                </div>
              </div>
              <div class="card-footer">
                <router-link :to="{ name: 'AuthProfile' }" class="btn btn-dark-blue">
                  <i class="fas"></i> Update Info
                </router-link>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AccountView",
  metaInfo: {
    title: "My Information",
  },
  components: {
    //
  },

  data: () => ({
    params: {},
    value: {},
    is_loading: false,
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),

  mounted: function () {
    if (this.isMobile()) {
      var sidebarElem = window.$(document).find(".sidebar-mini");
      if ($(sidebarElem).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    let _this = this;
    // _this.param = _this.$route.params;
    _this.getAccountDetail();
  },

  computed: {
    ...mapGetters(["profile", "accountInfo"]),
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `My Information | ${this.companyName}`
        : "My Information",
    };
  },

  methods: {
    ...mapActions(["FETCH_PROFILE", "FETCH_ACCOUNT_INFO"]),

    getAccountDetail: function () {
      this.is_loading = true;
      this.FETCH_ACCOUNT_INFO()
        .then((response) => {

        }).catch((error) => {

        }).finally(() => {
          this.is_loading = false;
        });

    },
  },
};
</script>
